// #region Imports

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { store } from '../redux/store';
import { INoteData } from '../dto/INoteData';
import { SelectorService } from '../services/SelectorService';

import NoteShowOrHide from '../components/noteShowOrHide';

// #endregion Imports

$(() => {
    markBodyTag();
    wireUpcomingTerms();
    updateUpcomingTerms();
    syncWidth();
    initializeNotes();
    ensureSoftLanding();
    syncStickyHeaderScrollPadding();
    renderComponents();
    window.addEventListener('resize', syncWidth);
    window.addEventListener('resize', syncStickyHeaderScrollPadding);
    window.addEventListener('syncHeader', () => {
        setTimeout(() => {
            syncWidth();
            syncStickyHeaderScrollPadding();
        }, 1000);
    }
    );
});

function renderComponents() {
    const container = document.getElementById('notes-show-or-hide');

    if (container) {
        const disableTools = container.getAttribute('data-disable-tools') == 'true';
        ReactDOM.render(
            <Provider store={store}>
                <NoteShowOrHide disableTools={disableTools} />
            </Provider>,
            container
        );
    }
}

function markBodyTag() {
    $('body').addClass('js-document');
}

function initializeNotes() {
    let notes: INoteData[] = (window as any).notes;
    if(!notes){
        notes = [];
    }
    const selectorService = new SelectorService();
    selectorService.initialize(notes);
}

function syncWidth() {
    const docHeader = document.querySelector('.document-sticky__document-header-left');
    if (!docHeader) {
        return;
    }
    const startPoint = docHeader.getBoundingClientRect().left;
    const endPoint = document.querySelector('.document-sticky__document-header-right')?.getBoundingClientRect().left;
    if (!endPoint) {
        return;
    }
    const documentWidth = document.querySelector('#documentcontent')?.getBoundingClientRect().width;
    const width = endPoint - startPoint -20;
    //docHeader.setAttribute('style', `width: ${documentWidth + 20}px; min-width: ${documentWidth + 20}px`);
}

function getStickyHeaderHeight(): number {
    let height = $(".header").outerHeight() || 0;

    const mobilNavHeight = $('.mobile-navigation').outerHeight();
    if (mobilNavHeight) {
        height += mobilNavHeight;
    }

    const docHeaderHeight = $('#documentHeader').outerHeight();
    if (docHeaderHeight) {
        height += docHeaderHeight;
    }

    return height;
}

function syncStickyHeaderScrollPadding() {
    document.documentElement.style.scrollPaddingTop = `${getStickyHeaderHeight()}px`;
}

function ensureSoftLanding() {
    const hash = document.location.hash;

    if (hash.length === 0) {
        return;
    }

    const $target = $(hash);

    if ($target.length !== 1) {
        return;
    }

    const position = $target.offset().top - getStickyHeaderHeight();
    $("html, body").animate({ scrollTop: position }, 500);
}

function wireUpcomingTerms() {
    $('.toggleUpcomingterms').click(e => {
        updateUpcomingTerms();
    });
}

function updateUpcomingTerms() {
    if ($('.toggleUpcomingterms').is(':checked')) {
        $('.lydelse').show();
        $('.node--wording').show();
    } else {
        $('.lydelse').hide();
        $('.node--wording').hide();
    }
}